import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-input-group-suffix',
  template: '<ng-content />'
})
export class InputGroupSuffixComponent {
}
